<div class="records-page records-page--tasks">
    <div class="records-page__section records-page__section--tabs">
        <div class="section-tabs-rail tasks-tabs" fxLayout="row wrap" fxLayoutAlign="space-between center">
            <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
                <button type="button" class="section-tab-button tasks-tab" [class.section-tab-button--active]="!showCompleted" (click)="toggleTab(false)">
                    <h2>{{ 'TO_DO' | translate }}</h2>
                </button>
                <button type="button" class="section-tab-button tasks-tab" [class.section-tab-button--active]="showCompleted" (click)="toggleTab(true)">
                    <h2>{{ 'COMPLETED' | translate }}</h2>
                </button>
            </div>
            <div class="records-page__controls tasks-page__filters" fxLayout="row wrap" fxLayoutAlign="start center">
                <ng-select class="tasks-page__saved-search-select" [items]="taskSavedSearches" bindLabel="name" bindValue="id"
                    [placeholder]="'SAVED_SEARCHES' | translate" [(ngModel)]="selectedSavedSearchId"
                    (ngModelChange)="onSavedSearchChange($event)" [clearable]="true">
                </ng-select>
                <button *ngIf="!showCompleted" type="button" class="gray-button tasks-page__toggle" (click)="toggleView()">
                    {{ showDashboard ? ('SHOW_TABLE' | translate) : ('SHOW_DASHBOARD' | translate) }}
                </button>
                <button *ngIf="showCompleted || !showDashboard" type="button" class="gray-button gray-button--toggle tasks-page__filter-button">
                    <label class="gray-button__toggle-content" for="showMyTasksCheckbox">
                        <input type="checkbox" id="showMyTasksCheckbox" [(ngModel)]="showOnlyMyTasks" (change)="onShowMyTasksChange()" value="{{ 'SHOW_ONLY_MY_TASKS' | translate }}">
                        {{ 'SHOW_ONLY_MY_TASKS' | translate }}
                    </label>
                </button>
                <div *ngIf="!showDashboard && !showCompleted" class="tasks-page__due-filter" fxLayout="row" fxLayoutAlign="start center">
                    <label>
                        {{ 'SHOW_ONLY_TASKS_WITH_DUE_DATE' | translate }}
                    </label>
                    <form [formGroup]="dtForm">
                        <ng-select formControlName="showTasksDue" (change)="onDueDateFilterChange()" class="tasks-page__due-select"
                            [clearable]="false" [searchable]="false">
                            <ng-option value="All">{{ 'ALL' | translate }}</ng-option>
                            <ng-option value="Overdue">{{ 'OVERDUE' | translate }}</ng-option>
                            <ng-option value="Today">{{ 'TODAY' | translate }}</ng-option>
                            <ng-option value="Upcoming">{{ 'UPCOMING' | translate }}</ng-option>
                        </ng-select>
                    </form>
                </div>
            </div>
        </div>
    </div>
    
    <div class="datatable-page-shell" [class.records-page__surface--dashboard]="showDashboard && !showCompleted">
        <div class="records-page__section datatable-page-surface">
            <ng-container *ngIf="showDashboard && !showCompleted">
                <app-tasks-dashboard [iSavedSearchId]="savedSearchId"></app-tasks-dashboard>
            </ng-container>
            <ng-container *ngIf="!showDashboard || showCompleted">
                <app-tasks-datatable
                    class="records-page__table"
                    [iSortColumn]="(showCompleted) ? 'completedOn' : 'title'"
                    [iSortDirection]="(showCompleted) ? 'desc' : 'asc'"
                    [iShowActions]="true"
                    [iShowDropDownDelete]="true"
                    [iShowDropDownEdit]="true"
                    [iShowExport]="false"
                    [iShowSelect]="true"
                    [iShowUserFilter]="true"
                    [iSelectedUserId]="selectedUserId"
                    (oRowClick)="editRow($event)"
                    [iUserRoles]="userRoles"
                    [isAdmin]="doWhat.isAdmin || false"
                    [iCanRead]="doWhat.canRead || false"
                    [iCanWrite]="doWhat.canWrite || false"
                    [iCanDelete]="doWhat.canDelete || false"
                    [iColumns]="(showCompleted) ? completedTasksColumns : columns"
                    (oBulkEditRows)="bulkEditRows($event)"
                    (oDeleteRows)="deleteRows($event)"
                    (oEditRow)="editRow($event)"
                    (oSelectedUserIdChange)="onUserFilterChange($event)"
                    [iData$]="todoTasksData"
                    [iSelectionResetToken]="selectionResetToken"
                    [iIsServerLoading]="!showUserFilter"
                    [iTotalCount]="dataTotalCount"
                    (oLoadDataFromServer)="onLoadingData($event)"
                    [iShowRedStyling]="!showCompleted">
                </app-tasks-datatable>
            </ng-container>
        </div>
    </div>
</div>
